/*产品溯源系统*/

/*主容器文件*/
const cpsy_ = () => import("../../../studio/sub_systems/cpsy_system/index");
/*首页*/
const cpsy_index_ = () => import("../../../studio/sub_systems/cpsy_system/index_page/index_page_main");

/*生产加工管理*/
const cpsy_index_scjggl = () => import("../../../studio/sub_systems/cpsy_system/index_page/scjggl/index");
/*包装仓储管理*/
const cpsy_index_bzccgl = () => import("../../../studio/sub_systems/cpsy_system/index_page/bzccgl/index");
/*物流运输*/
const cpsy_index_wlysgl = () => import("../../../studio/sub_systems/cpsy_system/index_page/wlysgl/index");


export default [
  {
    path: '/cpsyxt',
    name: '农资产品质量安全监管追溯',
    redirect: '/cpsyxt/index',
    component: cpsy_,
    children: [
      {
        path: '/cpsyxt/index',
        redirect: '/cpsyxt/index/scjggl',
        name: '首页',
        component: cpsy_index_,
        children: [
          {
            path: '/cpsyxt/index/scjggl',
            name: '生产加工管理',
            component: cpsy_index_scjggl,
          },
          {
            path: '/cpsyxt/index/bzccgl',
            name: '包装仓储管理',
            component: cpsy_index_bzccgl,
          },
          {
            path: '/cpsyxt/index/wlysgl',
            name: '物流运输管理',
            component: cpsy_index_wlysgl,
          },


        ]
      },

    ]
  },

]



// WEBPACK FOOTER //
// ./src/router/modules/cpsy/cpsy_system_page.js